/* @flow */

import BusinessPotential from './businessPotential';

export default class BusinessPotentials {
  businessPotentials: BusinessPotential[];
  minimumAverageInvoiceAmount: number;
  minimumYearlyAmount: number;
}
